import React from "react";
import { BsFillPatchCheckFill } from "react-icons/bs";
import "./experience.css";

const Experience = () => {
  return (
    <section id="experience">
      <h5>The Skills I Have</h5>
      <h2>Skills</h2>

      <div className="container experience__container">
        {/* Languages */}
        <div className="experience__card">
          <h3>Languages</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>JavaScript (ES6+)</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>TypeScript</h4>
            </article>
          </div>
        </div>

        {/* Frontend */}
        <div className="experience__card">
          <h3>Frontend</h3>
          <div className="experience__content">
            {[
              "React",
              "Next.js",
              "React Native",
              "Tailwind",
              "Bootstrap",
              "SCSS",
            ].map((skill) => (
              <article key={skill} className="experience__details">
                <BsFillPatchCheckFill className="experience__details-icon" />
                <h4>{skill}</h4>
              </article>
            ))}
          </div>
        </div>

        {/* Backend */}
        <div className="experience__card">
          <h3>Backend</h3>
          <div className="experience__content">
            {["Node.js", "Express.js", "Firebase"].map((skill) => (
              <article key={skill} className="experience__details">
                <BsFillPatchCheckFill className="experience__details-icon" />
                <h4>{skill}</h4>
              </article>
            ))}
          </div>
        </div>

        {/* Databases */}
        <div className="experience__card">
          <h3>Databases</h3>
          <div className="experience__content">
            {["Firestore", "MySQL", "MongoDB", "Supabase"].map((skill) => (
              <article key={skill} className="experience__details">
                <BsFillPatchCheckFill className="experience__details-icon" />
                <h4>{skill}</h4>
              </article>
            ))}
          </div>
        </div>

        {/* WordPress */}
        <div className="experience__card">
          <h3>WordPress</h3>
          <div className="experience__content">
            {["Elementor", "WooCommerce", "ACF", "Custom"].map((skill) => (
              <article key={skill} className="experience__details">
                <BsFillPatchCheckFill className="experience__details-icon" />
                <h4>{skill}</h4>
              </article>
            ))}
          </div>
        </div>

        {/* Tools */}
        <div className="experience__card">
          <h3>Tools</h3>
          <div className="experience__content">
            {["Git", "Puppeteer", "Vercel", "Netlify"].map((skill) => (
              <article key={skill} className="experience__details">
                <BsFillPatchCheckFill className="experience__details-icon" />
                <h4>{skill}</h4>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
